(function(angular) {
    angular.module('bizPartEngage').config(configCoreFunction);
    configCoreFunction.$inject = ["$stateProvider", "bizUserProvider", "bizCoreProvider", "$translatePartialLoaderProvider"];
    function configCoreFunction($stateProvider, bizUserProvider, bizCoreProvider, $translatePartialLoaderProvider) {

        $stateProvider
            .state('base.core', {
                template: '<div ui-view></div>'
            })
            .state('base.core.profile', {
                url: "/profile",
                templateUrl: bizCoreProvider.getView('base.core.profile', 'FrontEnd/Core/Views/profile.html')
            })
            .state('base.core.cleanprofile', {
                url: "/cprofile",
                template: "<div ui-view></div>"
            })
            .state('base.core.profile.home', {
                url: "/home",
                templateUrl: bizCoreProvider.getView('base.core.profile.home', 'FrontEnd/Core/Views/mypage.html'),
                controller: bizCoreProvider.getController('base.core.profile.home', 'core.mypage'),
                controllerAs: "vm",
                data: {
                    rule: function () { return bizUserProvider.IsLoggedIn(); },
                    parentState: "base.core.profile"
                }
            })
            .state('base.core.profile.settings', {
                url: "/settings",
                templateUrl: bizCoreProvider.getView('base.core.profile.settings', 'FrontEnd/Core/Views/mysettings.html'),
                controller: bizCoreProvider.getController('base.core.profile.settings', 'core.mysettings'),
                controllerAs: "vm",
                data: {
                    rule: function () { return bizUserProvider.IsLoggedIn(); },
                    parentState: "base.core.profile"
                }
            })
            .state('base.core.profile.security', {
                url: "/security",
                templateUrl: bizCoreProvider.getView('base.core.profile.security', 'FrontEnd/Core/Views/mysecurity.html'),
                controller: bizCoreProvider.getController('base.core.profile.security', 'core.mysecurity'),
                controllerAs: "vm",
                data: {
                    rule: function () { return bizUserProvider.IsLoggedIn(); },
                    parentState: "base.core.profile.settings"
                }
            })
            .state('base.core.profile.myrelatedusers', {
                url: "/my-related-users",
                templateUrl: bizCoreProvider.getView('base.core.profile.myrelatedusers', 'FrontEnd/Core/Views/myrelatedusers.html'),
                controller: bizCoreProvider.getController('base.core.profile.myrelatedusers', 'core.myrelatedusers'),
                controllerAs: "vm",
                data: {
                    rule: function () { return bizUserProvider.IsLoggedIn(); },
                    parentState: "base.core.profile.settings"
                }
            })
            .state('base.core.cleanprofile.myrelatedusers', {
                url: "/my-related-users",
                templateUrl: bizCoreProvider.getView('base.core.profile.myrelatedusers', 'FrontEnd/Core/Views/myrelatedusers.html'),
                controller: bizCoreProvider.getController('base.core.profile.myrelatedusers', 'core.myrelatedusers'),
                controllerAs: "vm",
                params: {
                    clean: true
                },
                data: {
                    rule: function () { return bizUserProvider.IsLoggedIn(); }                    
                }
            })
            .state('base.core.profile.customsettings', {
                url: "/customsettings",
                templateUrl: bizCoreProvider.getView('base.core.profile.customsettings', 'FrontEnd/Core/Views/mycustomsettings.html'),
                controller: bizCoreProvider.getController('base.core.profile.customsettings', 'core.mycustomsettings'),
                controllerAs: "vm",
                data: {
                    rule: function () { return bizUserProvider.IsLoggedIn(); },
                    parentState: "base.core.profile.settings"
                }
            })
            .state('base.core.profile.leaderboards', {
                url: "/leaderboards",
                templateUrl: bizCoreProvider.getView('base.core.profile.leaderboards', 'FrontEnd/Core/Views/myleaderboards.html'),
                controller: bizCoreProvider.getController('base.core.profile.leaderboards', 'core.myleaderboards'),
                controllerAs: "vm",
                data: {
                    rule: function () { return bizUserProvider.IsLoggedIn(); },
                    parentState: "base.core.profile"
                }
            })
            .state('base.core.profile.colleagues', {
                url: "/colleagues",
                templateUrl: bizCoreProvider.getView('base.core.profile.colleagues', 'FrontEnd/Core/Views/mycolleagues.html'),
                controller: bizCoreProvider.getController('base.core.profile.colleagues', 'core.mycolleagues'),
                controllerAs: "vm",
                data: {
                    rule: function () { return bizUserProvider.HasModuleAccess('UNITS', bizUserProvider.AccessTypeRight.Read); },
                    parentState: "base.core.profile"
                }
            })
            .state('base.core.register', {
                url: "/register",
                templateUrl: bizCoreProvider.getView('core.register', 'FrontEnd/Core/Views/register.html'),
                controller: bizCoreProvider.getController('core.register', 'core.register'),
                controllerAs: "vm",
                data: {
                    isPublic: IsPortalSettingTrue('IsCreateUserPublic')
                }
            })
            .state('base.core.showterms', {
                url: "/terms",
                templateUrl: bizCoreProvider.getView('base.core.showterms', 'FrontEnd/Core/Views/showterms.html'),
                controller: "core.terms.show",//bizCoreProvider.getController('core.terms.show', 'core.terms'),
                controllerAs: "vm"
            })
            .state('base.core.privacypolicy', {
                url: "/privacy-policy",
                templateUrl: bizCoreProvider.getView('base.core.privacypolicy', 'FrontEnd/Core/Views/privacypolicy.html'),
                data: {
                    rule: function () { return bizUserProvider.IsLoggedIn(); }
                }
            })
            .state('cleanbase.privacypolicy', {
                url: "/public-privacy-policy",
                templateUrl: bizCoreProvider.getView('cleanbase.privacypolicy', 'FrontEnd/Core/Views/privacypolicy.html'),
                data: {
                    isPublic: true
                }
            })
            .state('base.core.welcome', {
                url: "/welcome",
                templateUrl: bizCoreProvider.getView('base.core.welcome', 'FrontEnd/Core/Views/welcome.html'),
                controller: bizCoreProvider.getController('base.core.welcome', 'core.welcome'),
                controllerAs: "vm"
            })
            .state('base.core.themestest', {
                url: "/themestest",
                templateUrl: bizCoreProvider.getView('base.core.themestest', 'FrontEnd/Core/Views/themestest.html'),
                controller: bizCoreProvider.getController('base.core.themestest', 'core.themestest'),
                controllerAs: "vm"
            })
            .state('base.core.notifications', {
                url: "/notifications",
                templateUrl: bizCoreProvider.getView('base.core.notifications', 'FrontEnd/Core/Views/notifications.html'),
                controller: bizCoreProvider.getController('base.core.notifications', 'core.notifications'),
                controllerAs: "vm"
            })
            .state('cleanbase.exthome', {
                url: "/exthome",
                params: {
                    extmode: true
                },
                templateUrl: bizCoreProvider.getView('cleanbase.exthome', 'FrontEnd/Core/Views/exthome.html'),
                controller: "cleanbase.exthome",
                controllerAs: "vm",
                data: {
                    rule: function () { return bizUserProvider.IsLoggedIn(); }
                }
            })
            .state('cleanbase.unsubscribe', {
                url: "/unsubscribe",
                templateUrl: bizCoreProvider.getView('cleanbase.unsubscribe', 'FrontEnd/Core/Views/unsubscribe.html'),
                controller: "cleanbase.unsubscribe",
                controllerAs: "vm",
                data: {
                    isPublic: true
                }
            })
            .state('cleanbase.completeregister', {
                url: "/complete-registration/:guid",
                templateUrl: bizCoreProvider.getView('cleanbase.completeregister', 'FrontEnd/Core/Views/completeregister.html'),
                controller: "cleanbase.completeregister",
                controllerAs: "vm",
                data: {
                    isPublic: true,
                    onlyLoggedOut: true,
                }
            });
    }

}(window.angular));